import { GenericHouseHold } from '@/types/households';
import Portfolio from '@/types/portfolio';
import { NAV_PATHS } from '@/utils/constants';

export const redirectToPortfolios = (
  portfolio: Portfolio,
  currentHousehold: GenericHouseHold | undefined,
  currentPath: string,
  showActionOnSave?: boolean,
): string | undefined => {
  const contactId = portfolio.contact?._id;
  const householdId = currentHousehold?.id;

  if (!contactId) {
    return undefined;
  }

  const contactPortfoliosPath = NAV_PATHS.CONTACT_PORTFOLIOS.replace(':contactId', contactId);
  const houseHoldsPath = householdId && NAV_PATHS.HOUSEHOLD_CONTACT_DETAILS.replace(':householdId', householdId).replace(':contactId', contactId);
  const redirectPath = householdId ? houseHoldsPath : contactPortfoliosPath;

  const alreadyOnPath = currentPath === redirectPath;
  const showAction = showActionOnSave && !alreadyOnPath;

  return showAction ? redirectPath : undefined;
};
